/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-cond-assign */
/* eslint-disable array-callback-return */
import $ from 'jquery';

interface Access {
  segments: string[];
  name: string;
  accessId: number;
}

interface Segment {
  value: boolean;
  text: string;
}

function _x(STR_XPATH: string) {
  const xresult = document.evaluate(
    STR_XPATH,
    document,
    null,
    XPathResult.ANY_TYPE,
    null,
  );
  const xnodes: any[] = [];
  let xres: any;
  while ((xres = xresult.iterateNext())) {
    xnodes.push(xres);
  }

  return xnodes;
}

export const CustomCheckBox: any = (
  SurveyKo: any,
  accesses: any,
  SurveyJSCreator: any,
  refreshCustomComponentsNames: any,
  refreshQuestionVisibility: any,
) => {
  refreshCustomComponentsNames();

  let segmentsArray: Segment[] = [];
  if (accesses) {
    accesses.map((access: Access) => {
      access.segments.map((segment: string) => {
        if (!segmentsArray.some(s => s.text === segment)) {
          segmentsArray.push({
            value: false,
            text: segment,
          });
        }
      });
    });

    if (segmentsArray) {
      segmentsArray = segmentsArray.sort((a: any, b: any) => {
        if (a.text < b.text) return -1;
        return a.text > b.text ? 1 : 0;
      });

      const checkboxSegmentsComponent = {
        render(editor: any, htmlElement: any) {
          const oldValuesToLoadChecked = editor.koValue() ?? [];
          const arraySegments: string[] = [];

          segmentsArray.map((item, i) => {
            const div = document.createElement('div');
            div.className = 'form-control svd_editor_control';
            div.style.marginBottom = '5px';
            div.style.width = '100%';
            div.style.cursor = 'pointer';

            const input = document.createElement('input');
            input.id = `ailton-checkbox-${i}`;
            input.type = 'checkbox';
            input.checked = oldValuesToLoadChecked.some(
              (segment: string) => segment === item.text,
            );
            input.value = item.text;

            const labelForCheckbox = document.createElement('label');
            labelForCheckbox.innerHTML = item.text;
            labelForCheckbox.setAttribute('for', `ailton-checkbox-${i}`);
            labelForCheckbox.style.marginLeft = '5px';

            div.appendChild(input);
            div.appendChild(labelForCheckbox);
            htmlElement.appendChild(div);

            $(input).on('change', function () {
              const arrToAdd: string[] = [];

              const oldVal = editor.koValue() ?? [];

              if (this.checked) {
                const newSetArray: string[] = [];
                newSetArray.push(this.value);
                arrToAdd.push(...oldVal, ...newSetArray);
              } else {
                const newSetArray = oldVal.filter(
                  (val: string) => val !== this.value,
                );
                arrToAdd.push(...newSetArray);
              }

              arraySegments.splice(0, arraySegments.length);
              arraySegments.push(...arrToAdd);

              let segmentList = '';

              arraySegments.map(seg => {
                segmentList = segmentList.concat(seg, ',');
                return segmentList;
              });

              const segmentListAsString = segmentList.slice(
                0,
                segmentList.length - 1,
              );

              const questionName = $(
                _x(
                  '/html/.//*[@id="creatorElement"]/div/div/div[2]/div/div/div/div[1]/div[1]/div/svd-designer-container/div[2]/div/div[2]/div/div/div/div[1]/svd-property-grid/div/div/div[1]/div/svd-dropdown/label/div/select',
                ),
              )
                .children('option:selected')
                .text();

              refreshQuestionVisibility(
                segmentListAsString,
                questionName.substring(2, questionName.length),
              );

              editor.koValue(arrToAdd);
            });
          });
        },
      };

      SurveyJSCreator.SurveyPropertyEditorFactory.registerCustomEditor(
        'customSegmentType',
        checkboxSegmentsComponent,
      );

      SurveyKo.JsonObject.metaData.addProperty('question', {
        name: 'Segments',
        type: 'customSegmentType',
        category: 'Segments',
        visibleIndex: 3,
      });
    }
  }
};
